import { useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import { useAffiliate } from 'hooks/webapi';
import { INTRO } from 'Router/routes';
import { containsHttps } from 'utils/containsHttps.ts';
import { datadogLogs } from '@datadog/browser-logs';

export default function AffiliatePage() {
  const { fetchAffiliate } = useAffiliate();
  const navigate = useNavigate();
  const location = useLocation();
  const { provider } = useParams();

  useEffect(() => {
    const fetchAffiliateSetCookie = async () => {
      fetchAffiliate({ provider, queryString: location.search })
        .then((fetchedAffiliate) => {
          datadogLogs.logger.info('Affiliate cookie was set successfully');
          if (fetchedAffiliate?.redirectUrl) {
            if (containsHttps(fetchedAffiliate?.redirectUrl)) {
              window.location.href = fetchedAffiliate?.redirectUrl;
              return;
            }

            navigate(fetchedAffiliate.redirectUrl);
            return;
          }

          navigate(INTRO);
        })
        .catch(() => {
          // Failure is already logged by fetchData and fetchAffiliate; a console.error
          // here would only add a duplicate RUM error for an expected invalid-link case
          navigate(INTRO);
        });
    };

    fetchAffiliateSetCookie();
  }, []);

  return null;
}
